import { render } from "./PTableFree.vue?vue&type=template&id=697dd514&scoped=true"
import script from "./PTableFree.vue?vue&type=script&lang=js"
export * from "./PTableFree.vue?vue&type=script&lang=js"

import "./PTableFree.vue?vue&type=style&index=0&id=697dd514&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-697dd514"]])

export default __exports__